<template>
    <div>
        <div v-if="goodsOrder.proxied == true || subOptionCode=='SellerRandomDeliver'" class="simple-row">
            <div class="left">
                <el-button class="el-search-btn" type="primary" v-if="checkActionPerm('alloc_by_proxy') && goodsOrder != null && goodsOrder.manualAllocFlag && !goodsOrder.cancelled" @click="goSwbOrderGoodsAllocItemSaveVue()">
                    <span>代配货</span>
                </el-button>
            </div>
        </div>
        <div v-if="goodsAllocDtoList.length > 0" v-for="goodsAllocDto in goodsAllocDtoList" class="table-layout mb30">
            <p style="line-height: 40px;background-color: #eef1f6;font-size: 14px;border: 1px solid #dfe6ec;border-bottom: 0px;">
                <span class="ml20"><b style="font-weight: bold;">配货标题：</b>{{goodsAllocDto.title || '无'}}</span>
                <span class="ml20"><b style="font-weight: bold;">业务单元：</b>{{goodsAllocDto.buyerBizUnitName}}</span>
                <span class="ml20"><b style="font-weight: bold;">所属部门：</b>{{goodsAllocDto.buyerShopName}}</span>
                <span class="ml20"><b style="font-weight: bold;">联系人：</b>{{goodsAllocDto.buyerRecvContractName || '无'}}</span>
                <span class="ml20"><b style="font-weight: bold;">联系电话：</b>{{goodsAllocDto.buyerRecvContactTel || '无'}}</span>
                <!--<span class="ml20"><b style="font-weight: bold;">收货地址：</b>{{goodsAllocDto.buyerRecvAddr || '无'}}</span>-->
                <!--<span class="mr20" style="float: right;"><a v-if="checkActionPerm('view')" @click="openOrderGoodsAllocItemDlg(goodsAllocDto.orderId, goodsAllocDto.buyerShopId, goodsAllocDto.buyerShopName);">查看明细</a></span>-->
            </p>
            <p style="line-height: 40px;background-color: #eef1f6;font-size: 14px;border: 1px solid #dfe6ec;border-top: 0px;">
                <span class="ml20"><b style="font-weight: bold;">收货地址：</b>{{goodsAllocDto.buyerRecvAddr || '无'}}</span>
            </p>
            <el-table :data="goodsAllocDto.itemList" border style="width: 100%">
                <el-table-column align="left" prop="title" label="商品名称"></el-table-column>
                <el-table-column align="left" prop="catName" label="分类名称" width="150"></el-table-column>
                <el-table-column align="left" prop="brandName" label="品牌名称" width="120"></el-table-column>
                <el-table-column align="right" prop="price" label="含税价(元)" width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.price || 0.00}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="taxRate" label="税率(%)" width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.taxRate || 0.00}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="ntxPrice" label="未税价(元)" width="80">
                    <template slot-scope="scope">
                        <span>{{scope.row.ntxPrice || 0.00}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="quantity" label="配货数量" width="80"></el-table-column>
                <el-table-column align="right" prop="shipQuantity" label="发货数量" width="100">
                    <template slot-scope="scope">
                        <span class="font-green" v-if="scope.row.shipQuantity != null">{{scope.row.shipQuantity}}</span>
                        <span class="font-green" v-else>0</span>
                    </template>
                </el-table-column>
                <el-table-column align="right" prop="recvQuantity" label="收货数量" width="80">
                    <template slot-scope="scope">
                        <span class="font-red" v-if="scope.row.recvQuantity != null">{{scope.row.recvQuantity}}</span>
                        <span class="font-red" v-else>0</span>
                    </template>
                </el-table-column>
                <!--<el-table-column align="left" prop="id" label="操作" width="80">-->
                <!--<template slot-scope="rows">-->
                <!--<a class="swb-btn-link" v-if="checkActionPerm('cut_down') && (goodsOrder.proxied == true || subOptionCode=='SellerRandomDeliver')" @click="reduceAllocItem(rows.row, goodsAllocDto)">调减</a>-->
                <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
        </div>
        <div v-if="goodsAllocDtoList.length <= 0">
            <div class="no-data">
                <i class="icon iconfont icon-zanwushuju mr10" style="font-size: 58px;vertical-align: middle;"></i>
                <span class="">暂无数据 . . .</span>
            </div>
        </div>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'

    import goodsOrderApi from '../../api/goodsOrder'

    import SwbOrderGoodsAllocItemSave from './OrderGoodsAllocItemSave';
    Routes.add(SwbOrderGoodsAllocItemSave);

    import SwbOrderGoodsAllocDetails from './OrderGoodsAllocDetails';
    Vue.regist(SwbOrderGoodsAllocDetails);

    import SwbOrderGoodsAllocItemReduce from './OrderGoodsAllocItemReduce';
    Vue.regist(SwbOrderGoodsAllocItemReduce);

    export default {
        name: 'swb-order-goods-alloc-item-list',
        desc: '配货信息列表',
        props: ['goodsOrderId', 'manualAllocFlag', 'selfPath'],
        data: function () {
            return {
                goodsOrder: {proxied: false},
                goodsAllocDtoList: [],
                subOptionCode: null
            }
        },
        created: function () {
            this.getTremVal(this.goodsOrderId);
            this.getGoodsOrderById();
            this.getGoodsAllocDtoList();
        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                // return checkUserActionPerm(this.selfPath, action, targetPostId);
                this.userActionPermCache = this.userActionPermCache || {};
                //
                let cacheKey = (action == null ? "" : action) + "::" + (targetPostId == null ? "" : targetPostId);
                let cacheValue = this.userActionPermCache[cacheKey];
                if(cacheValue == null) {
                    //原生调用
                    cacheValue = checkUserActionPerm(this.selfPath, action, targetPostId);
                    this.userActionPermCache[cacheKey] = cacheValue;
                }
                return cacheValue;
            },
            // 配货页面
            goSwbOrderGoodsAllocItemSaveVue: function () {
                let pushDate = {};
                pushDate.path = SwbOrderGoodsAllocItemSave.path;
                if(this.goodsOrderId != null) {
                    pushDate.query = {orderId: this.goodsOrderId};
                }
                this.$router.push(pushDate);
            },
            getGoodsOrderById: function () {
                let self = this;
                let postData = {};
                postData.id = self.goodsOrderId;
                goodsOrderApi.getGoodsOrderInfo(postData, function (result) {
                    if(result.type == "info") {
                        self.goodsOrder = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 配货信息列表
            getGoodsAllocDtoList: function () {
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.orderId = self.goodsOrderId;
                postData.filterItems = filterItems;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getOrderGoodsAllocFormListByOrderId(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let goodsAllocDtoList = result.data || [];
                        for(let i = 0; i < goodsAllocDtoList.length; i++) {
                            let goodsAllocDto = goodsAllocDtoList[i];
                            let itemList = goodsAllocDto.itemList || [];
                            for(let j = 0; j < itemList.length; j++) {
                                let item = itemList[j];
                                item.devcName = item.title || '' + item.model || '' + item.fixedSpec || '';
                                item.price = Utils.isNoB(item.price) ? 0.00 : parseFloat(item.price).toFixed(2);
                                item.taxRate = Utils.isNoB(item.taxRate) ? 0.00 : parseFloat(item.taxRate).toFixed(2);
                                item.ntxPrice = Utils.isNoB(item.ntxPrice) ? 0.00 : parseFloat(item.ntxPrice).toFixed(2);
                            }
                            goodsAllocDto.itemList = Utils.merge([], itemList);
                        }
                        self.goodsAllocDtoList = Utils.merge([], goodsAllocDtoList);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            getTremVal: function (goodsOrderId) {
                let self = this;
                let filter = {};
                filter.goodsOrderId = goodsOrderId;
                filter.ruleCode = 'TradePhase';
                filter.ruleOptionCode = 'Deliver';
                //
                let msgBoxDlg = MsgBox.loading();
                goodsOrderApi.getDeliverCodeByContractId(filter, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        self.subOptionCode = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            reduceAllocItem: function (item, goodsAllocDto) {
                let shipQuantity = item.shipQuantity;
                let expectExchangeQuantity = item.expectExchangeQuantity;
                let quantity = item.quantity;
                let reductionQuantity = quantity - (shipQuantity - expectExchangeQuantity);
                if(reductionQuantity <= 0) {
                    MsgBox.warning("没有可调减的数量啦！");
                    return;
                }
                let self = this;
                Vue.$showDialog({
                    title: '调减信息',
                    width: 600,
                    height: 400,
                    showCloseBtn: true,
                    cancleVisible: false,
                    template: '<div>' +
                    '<swb-order-goods-alloc-reduce :title="title" :quantity="quantity" :maxQuantity = "maxQuantity" ref="swb_order_goods_alloc_reduce"></swb-order-goods-alloc-reduce>' +
                    '</div>',
                    data: {
                        title: item.title,
                        quantity: quantity,
                        maxQuantity: reductionQuantity
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_order_goods_alloc_reduce.getDlgResult() || null;
                        if(result.type === 'info') {
                            //
                            let postData = {};
                            postData.quantity = result.reduceQuantity;
                            postData.orderItemId = item.orderItemId;
                            postData.buyerShopId = goodsAllocDto.buyerShopId;
                            postData.buyerShopName = goodsAllocDto.buyerShopName;
                            postData.buyerId = goodsAllocDto.buyerId;
                            //
                            let theLoad = MsgBox.loading();
                            goodsOrderApi.reduceGoodsAllocItemDo(postData, function (result) {
                                theLoad.hide();
                                if(result.type === 'info') {
                                    //
                                    Toast.show('调减成功！', 2000, 'success');
                                    self.getGoodsAllocDtoList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                            return true;
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    },
                    methods: {}
                });
            },

            // 作废
            invalidAlloc: function (id) {
                let self = this;
                self.$confirm('是否确认作废', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let msgBoxDlg = MsgBox.loading();
                    goodsOrderApi.invalidateOrderGoodsAllocItem(id, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            MsgBox.success("成功");
                            self.getGoodsAllocDtoList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    })
                }).catch(function () {
                });
            },
            // 店铺配货详情
            openOrderGoodsAllocItemDlg: function (orderId, buyerShopId, buyerShopName) {
                let title = "查看【" + buyerShopName + "】机构配货详情";
                Vue.$showDialog({
                    title: title,
                    width: 1000,
                    height: 500,
                    showCloseBtn: true,
                    okVisible: false,
                    cancelText: '关闭',
                    template: '<div>' +
                    '<swb-order-goods-alloc-details :orderId="orderId" :buyerShopId="buyerShopId"  ref="swb_order_goods_alloc_details"></swb-order-goods-alloc-details>' +
                    '</div>',
                    data: {
                        orderId: orderId,
                        buyerShopId: buyerShopId
                    },
                    methods: {},
                    okClicked: function () {

                    },
                    lifecycle: {}
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocItemList.vue